import { Box, Card, CardContent, Modal, Typography, useMediaQuery, useTheme } from "@mui/material";
import MDButton from "components/MDButton";

import FlexWrapper from "components/Wrapper/FlexWrapper";

const ConfirmationModal = ({ title, isOpen, onClose, onConfirm, body }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Card
        sx={{
          position: "absolute",
          width: {
            xs: "90%",
            sm: "70%",
            md: "50%",
            lg: "30%",
            xl: "25%",
          },
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          maxHeight: { xs: "80vh", sm: "auto" },
          overflow: "auto",
        }}
      >
        <CardContent>
          <FlexWrapper
            sx={{
              py: "10px",
              flexDirection: isMobile ? "column" : "column",
              gap: 2,
            }}
          >
            <Typography sx={{ mb: isMobile ? "10px" : "20px", fontWeight: "bold" }}>
              {title}
            </Typography>
            {body && <Box>{body}</Box>}
            <Box
              sx={{
                marginLeft: isMobile ? "0" : "auto",
                display: "flex",
                justifyContent: "flex-end",
                width: isMobile ? "100%" : "auto",
                gap: 1,
              }}
            >
              <MDButton onClick={onClose} color="error" variant="text">
                Cancel
              </MDButton>
              <MDButton onClick={onConfirm} color="info" variant="contained">
                Confirm
              </MDButton>
            </Box>
          </FlexWrapper>
        </CardContent>
      </Card>
    </Modal>
  );
};

export default ConfirmationModal;
